export default "__VITE_ASSET__CAPbOIGR__"